import Exception from './Exception';
/**
 * Custom Error class of type Exception.
 */
class ArithmeticException extends Exception {
}
ArithmeticException.kind = 'ArithmeticException';
export default ArithmeticException;
